import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MapIcon from "@material-ui/icons/Map";
import axios from "axios";

import ApiTour from "../../../API/ApiTour";
import ApiUser from "../../../API/ApiUser";
import ApiGameAnalytics from "../../../API/ApiGameAnalytics";
import styles from "./homeStyles";
import HomeView from "./homeView";
import qs from "qs";
import {
  isSessionLive,
  POLL_INTERVAL_MS,
} from "../teamPhotos/sessionUtils";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      isAdmin: false,
      tourIdSelected: -1,
      testCode: null,
      codeListRef: null,
      leaderboardActivated: false,
      accountStripeConnectActive: false,
      tourSelected: null,
      textPrompt: null,
      aiTourCreationIsLoading: false,
      aiTourIsQRCode: false,
      zonesNb: 2,
      enigmasPerZone: 2,
      generateImages: false,
      isTemplateTourDialogOpen: false,
      toursReload: 0,
      templateSuccessMessage: "",
      liveSessionsCount: 0,
      liveSessionsCheckedAt: null,
    };

    // Suivi en direct du parcours sélectionné : même mécanique que la page
    // sessions (polling silencieux, suspendu en arrière-plan).
    this.liveTimer = null;

    this.onTourSelection = this.onTourSelection.bind(this);
    this.setCodeListRef = this.setCodeListRef.bind(this);
    this.handleTextPromptChange = this.handleTextPromptChange.bind(this);
    this.handleGenerateTourWithAI = this.handleGenerateTourWithAI.bind(this);
    this.handleSwitchAiTourIsQrCode =
      this.handleSwitchAiTourIsQrCode.bind(this);
    this.handleZonesNbChange = this.handleZonesNbChange.bind(this);
    this.handleEnigmasPerZoneChange =
      this.handleEnigmasPerZoneChange.bind(this);
    this.handleGenerateImages = this.handleGenerateImages.bind(this);
    this.handleOpenTemplateTourDialog = this.handleOpenTemplateTourDialog.bind(this);
    this.handleCloseTemplateTourDialog = this.handleCloseTemplateTourDialog.bind(this);
    this.handleTemplateTourCopied = this.handleTemplateTourCopied.bind(this);
    this.handleTemplateCopyAlert = this.handleTemplateCopyAlert.bind(this);
    this.handleResetTemplateAlert = this.handleResetTemplateAlert.bind(this);
  }

  componentDidMount() {
    document.title = "Parcours | Landing Zone";

    this.getJWTTokenFromGoogleIfExists();
    this.setStateIsAdmin();
    this.getUser();

    const successMessage = this.props.location?.state?.successMessage;
    if (successMessage) {
      this.setState({ templateSuccessMessage: successMessage, toursReload: this.state.toursReload + 1 });
      this.props.history.replace("/", {});
    }

    this.liveTimer = setInterval(() => {
      if (document.visibilityState === "hidden") return;
      this.refreshLiveSessions();
    }, POLL_INTERVAL_MS);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentWillUnmount() {
    if (this.liveTimer) clearInterval(this.liveTimer);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      this.refreshLiveSessions();
    }
  };

  // Compte les parties encore ouvertes sur le parcours sélectionné. Une erreur
  // réseau laisse le compteur précédent en place plutôt que de le remettre à 0.
  refreshLiveSessions = async () => {
    const tourId = this.state.tourIdSelected;
    if (!tourId || tourId === -1) return;

    const response = await ApiGameAnalytics.getSessions(
      tourId,
      1,
      100,
      "created_at"
    );
    if (response.status !== 200 || !response.data?.items) return;

    this.setState({
      liveSessionsCount: response.data.items.filter(isSessionLive).length,
      liveSessionsCheckedAt: new Date(),
    });
  };

  handleGenerateImages = (event) => {
    this.setState((prevState) => ({
      ...prevState,
      generateImages: event.target.checked,
    }));
  };

  handleZonesNbChange = (event) => {
    this.setState((prevState) => ({
      ...prevState,
      zonesNb: event.target.value,
    }));
  };

  handleEnigmasPerZoneChange = (event) => {
    this.setState((prevState) => ({
      ...prevState,
      enigmasPerZone: event.target.value,
    }));
  };

  handleTextPromptChange = (event) => {
    console.log("text changed");
    this.setState((prevState) => ({
      ...prevState,
      textPrompt: event.target.value,
    }));
  };

  handleSwitchAiTourIsQrCode = (event) => {
    this.setState((prevState) => ({
      ...prevState,
      aiTourIsQRCode: event.target.checked,
    }));
  };

  handleGenerateTourWithAI = async () => {
    console.log("handleGenerateTourWithAI");
    if (!this.state.textPrompt) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: "Impossible de générer un parcours sans description",
        showSuccess: false,
      }));
      return;
    }
    this.setState({ loading: true });

    try {
      this.setState((prevState) => ({
        ...prevState,
        aiTourCreationIsLoading: true,
      }));
      const response = await ApiTour.generateTourWithAI(
        this.state.textPrompt,
        this.state.aiTourIsQRCode,
        this.state.zonesNb,
        this.state.enigmasPerZone,
        this.state.generateImages
      );
      this.setState((prevState) => ({
        ...prevState,
        aiTourCreationIsLoading: false,
      }));
    } catch (error) {
      console.error("Error generating enigma:", error);
    }
  };

  getJWTTokenFromGoogleIfExists() {
    console.log("getting token");
    let token = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).token;

    if (token) {
      // Stocker le token dans le localStorage
      localStorage.setItem("token", token);

      // Configurer l'en-tête Authorization pour les futures requêtes
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }

  async getUser() {
    let response = await ApiUser.getAccount();

    if (response.status == 200) {
      console.log(
        "response.data.stripeConnectUserInfos?.accountStripeConnectActive ",
        response.data.stripeConnectUserInfos?.accountStripeConnectActive
      );
      this.setState((prevState) => ({
        ...prevState,
        user: response.data,
        leaderboardActivated:
          response.data.role !== "PACK_DECOUVERTE" &&
          response.data.role !== "PACK_ESSAIE" &&
          response.data.role !== "NO_SUBSCRIBTION" &&
          response.data.role !== "NEW_MEMBER",
        accountStripeConnectActive:
          response.data.stripeConnectUserInfos?.accountStripeConnectActive,
      }));
    }
  }

  async setStateIsAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        isAdmin: response.data.isAdmin,
      }));
    }
  }

  async onTourSelection(tourId) {
    this.setState(
      (prevState) => ({
        ...prevState,
        tourIdSelected: tourId,
        // Le compteur du parcours précédent ne veut plus rien dire.
        liveSessionsCount: 0,
        liveSessionsCheckedAt: null,
      }),
      this.refreshLiveSessions
    );
    const res = await ApiTour.getFirstTestCode(tourId);
    this.setState((prevState) => ({
      ...prevState,
      testCode: res.data?.code,
    }));
    const responseTour = await ApiTour.getTour(tourId);
    if (responseTour.status == 200) {
      console.log("responseTour.data ", responseTour.data);
      this.setState((prevState) => ({
        ...prevState,
        tourSelected: responseTour.data,
      }));
    }
  }

  handleOpenTemplateTourDialog() {
    this.setState({ isTemplateTourDialogOpen: true });
  }

  handleCloseTemplateTourDialog() {
    this.setState({ isTemplateTourDialogOpen: false });
  }

  handleTemplateTourCopied() {
    this.setState((prevState) => ({
      toursReload: prevState.toursReload + 1,
    }));
    this.getUser();
  }

  handleTemplateCopyAlert(message) {
    this.setState({ templateSuccessMessage: message });
  }

  handleResetTemplateAlert() {
    this.setState({ templateSuccessMessage: "" });
  }

  setCodeListRef = (ref) => {
    console.log("code list redf");
    this.setState({ codeListRef: ref });
  };

  handleOpenAddCodeDialog = () => {
    if (this.state.codeListRef) {
      this.state.codeListRef.handleOpenAddCodeDialog();
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <HomeView
          {...this.props}
          classes={classes}
          role={this.state.user?.role}
          hasTrial={this.state.user?.hasTrial}
          state={this.state}
          onTourSelection={this.onTourSelection}
          handleOpenAddCodeDialog={this.handleOpenAddCodeDialog}
          setCodeListRef={this.setCodeListRef}
          handleTextPromptChange={this.handleTextPromptChange}
          handleGenerateTourWithAI={this.handleGenerateTourWithAI}
          handleSwitchAiTourIsQrCode={this.handleSwitchAiTourIsQrCode}
          handleZonesNbChange={this.handleZonesNbChange}
          handleEnigmasPerZoneChange={this.handleEnigmasPerZoneChange}
          handleGenerateImages={this.handleGenerateImages}
          handleOpenTemplateTourDialog={this.handleOpenTemplateTourDialog}
          handleCloseTemplateTourDialog={this.handleCloseTemplateTourDialog}
          handleTemplateTourCopied={this.handleTemplateTourCopied}
          handleTemplateCopyAlert={this.handleTemplateCopyAlert}
          handleResetTemplateAlert={this.handleResetTemplateAlert}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Home);
